import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of, concat } from 'rxjs';
import * as DocumentActions from '../../store/documents/documents.actions';
import { DocumentService } from '../../services/document-service';
import * as Helpers from './documents.helpers';
import { DocumentType } from '../../enums/document-type';
import { createPickListsAsync } from '../printing/async-printing/pick-lists';
import { createLocationBarcodeAsync } from '../printing/async-printing/location-barcode';
import Global from '../global-selectors';

export const printDocument = (action$) => {
  return action$.pipe(
    ofType(DocumentActions.PRINT_DOCUMENT),
    mergeMap(({ documentType, documentIds, printSetting, templateId, printUrl }) => {
      const printDocumentObservables = DocumentService.getPrintDocumentActions(
        printSetting,
        documentType,
        documentIds,
        templateId,
        printUrl,
      ).map((action) => of(action));
      return concat(...printDocumentObservables);
    }),
  );
};

export const downloadDocument = (action$, { getState } = {}) => {
  return action$.pipe(
    ofType(DocumentActions.DOWNLOAD_DOCUMENT),
    mergeMap(({ documentType, documentIds, templateId, providedDownloadUrl }) => {
      if (documentType.identifier === DocumentType.PickList.identifier) {
        return createPickListsAsync({
          fulfillmentPlanIds: documentIds,
        }).pipe(
          mergeMap((printJob) => {
            const actions = Helpers.downloadDocument(printJob.printUrl, documentType, printJob.ids);
            return of(...actions);
          }),
        );
      }

      if (documentType.identifier === DocumentType.LocationBarcode.identifier) {
        const state = getState();
        const locationObjects = documentIds
          .map((locationId) => Global.selectSellerInventoryWarehouseLocationsById(state, { inventoryWarehouseLocationId: locationId }))
          .filter(Boolean);

        return createLocationBarcodeAsync({
          locations: locationObjects,
          printType: 'download',
        }).pipe(
          mergeMap((printJob) => {
            const actions = Helpers.downloadDocument(printJob.printUrl, documentType, printJob.ids);
            return of(...actions);
          }),
        );
      }

      const actions = Helpers.downloadDocument(providedDownloadUrl, documentType, documentIds, templateId);
      return of(...actions);
    }),
  );
};
